/**
 * quantityForecasts selectors
 */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import isEqual from 'lodash.isequal';

interface State {
    quantityForecasts: {
        [string]: {
            name: string
        }
    };
}

interface Props {
    quantityForecastId?: number | string;
}

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

const selectQuantityForecasts = (state: State) => state.quantityForecasts;
const selectQuantityForecastId = (state: State, props: Props) =>
    props.quantityForecastId && `${props.quantityForecastId}`;

const selectQuantityForecast = createDeepEqualSelector(
    selectQuantityForecasts,
    selectQuantityForecastId,
    (quantityForecastsState, quantityForecastId) =>
        quantityForecastId && quantityForecastsState[quantityForecastId]
);

const makeSelectQuantityForecastValue = (field: string) =>
    createDeepEqualSelector(
        selectQuantityForecast,
        quantityForecastState =>
            quantityForecastState && quantityForecastState[field]
    );

export {
    selectQuantityForecasts,
    selectQuantityForecast,
    makeSelectQuantityForecastValue
};
